import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactTags from 'react-tag-autocomplete'

import styles from './styles.css'

const Tag = ({ classNames, onDelete, tag }) => (
  <div
    className={classNames.selectedTag}
    title="Click to remove tag"
    onClick={onDelete}
    role="button"
  >
    <span className={classNames.selectedTagName}>{tag.name}</span>
  </div>
)

Tag.propTypes = {
  classNames: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  tag: PropTypes.object.isRequired,
}

/**
 * For all available options see plugin documentation
 * @link https://github.com/i-like-robots/react-tags
 */

class Search extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ),
    suggestions: PropTypes.func,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    keyFunc: PropTypes.func,
    single: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    label: '',
    suggestions: [],
    value: [],
    placeholder: '',
    keyFunc: x => x,
    onChange: tags => console.log('tags updated:', tags),
    single: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      suggestions: [],
    }
  }

  async onInputChange(input) {
    const { keyFunc, suggestions } = this.props
    const value = this.getValue()

    if (!input) {
      return
    }

    const results = await suggestions(input)
    const keys = value.map(keyFunc)
    const diff = results.filter(tag => keys.indexOf(keyFunc(tag)) === -1)

    this.setState({ suggestions: [...diff] })
  }

  onAdd = tag => {
    const value = this.getValue()
    const tags = [...new Set([].concat(value, tag))]
    this.props.onChange(tags)
  }

  onDelete = index => {
    const value = this.getValue()
    if (value.length) {
      value.splice(index, 1)
      this.props.onChange(value)
    }
  }

  getValue() {
    return this.props.value || []
  }

  render() {
    const {
      className,
      label,
      placeholder,
      single,

      ...restProps
    } = this.props
    const value = this.getValue()

    return (
      <div
        className={classnames(styles.root, className, {
          [styles.hideInput]: single && (value || []).length > 0,
        })}
      >
        {label && <div className={styles.label}>{label}</div>}

        <ReactTags
          autofocus={false}
          autoresize={false}
          tagComponent={Tag}
          {...restProps}
          suggestions={this.state.suggestions}
          tags={value}
          placeholder={placeholder}
          handleAddition={this.onAdd}
          handleDelete={this.onDelete}
          handleInputChange={this.onInputChange.bind(this)}
        />
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ../source/components/Search/index.js